import { React } from "react";

const Hero = () => {
    return (
        <>
            <div className="hero-contact position-relative overflow-hidden p-5 p-md-5 text-center">
                <div className="d-flex flex-column justify-content-center align-items-center col-md-10 p-lg-5 mx-auto my-5 text-primary fw-bold">
                    <h1 className="display-1 fw-bold m-5 text-white"
                        data-aos="fade-down"
                        data-aos-duration="1000">Strike up a conversation</h1>
                    <p className="lead fw-normal text-white"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        data-aos-delay="200">It’s time to come together and work towards creating ground-breaking experience that will take your brand to an exceptional level.</p>
                </div>
                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>
        </>
    )
}

export default Hero